import { render, staticRenderFns } from "./Zsmgl.vue?vue&type=template&id=405dd55e&scoped=true&"
import script from "./Zsmgl.vue?vue&type=script&lang=js&"
export * from "./Zsmgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405dd55e",
  null
  
)

export default component.exports